<template>
    <div>
        <form class="add-user-form" id="form_setari" method="POST">
          <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div class="table-header">
                        <h4> {{$t('txt.setariAlerteTitlu')}} </h4>
                    </div>
                    <div class="alert-message">
                        <p>
                            {{$t('txt.setariAlerteRand1')}}
                        </p>
                        <p>
                            {{$t('txt.setariAlerteRand2')}}
                        </p>
                    </div>
                    <div class="settings-alerts">
                        <div class="alert-checkbox-container">
                            <div class="alert-checkbox" v-for="checkbox in input_fields.checkbox" :key="checkbox.inputName">
                                <label>
                                    <input type="checkbox"
                                           :name="checkbox.inputName"
                                           v-model="checkbox.inputValue">
                                    <span class="checkbox-material">
                                      <span class="check"></span>
                                    </span> {{ checkbox.labelName }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="save-alerts-button">
                        <button type="button" @click.prevent="saveSettings()">
                            <i class="fas fa-check"></i>
                            {{$t('salveaza')}}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import ClientsService from '../../api-services/clients.service.js'
import UsersService from '../../api-services/users.service.js'

export default {
  name: 'settings',
  data () {
    return {
      client: [],
      userId: null
    }
  },
  methods: {
    getClient () {
      let userObj = JSON.parse(localStorage.getItem('user'))
      this.userId = userObj.id
      ClientsService.get(this.userId)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.client = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    saveSettings () {
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('form_setari'))
      formData.append('user_id', this.userId)
      UsersService.updateAlerts(formData)
        .then((response) => {
          this.$store.dispatch('showLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.modificariSucces'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            window.scrollTo(0, 0)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    }
  },
  created () {
    this.$store.dispatch('hideLoading')
    this.getClient()
  },
  computed: {
    input_fields () {
      return {
        checkbox: [
          {
            inputName: 'alerte_raspuns_mesaje',
            labelName: this.$t('placeholder.alerte_raspuns_mesaje'),
            inputValue: (this.client.alerts) ? this.client.alerts.alerte_raspuns_mesaje : null
          },
          {
            inputName: 'alerte_raspuns_reclamatii',
            labelName: this.$t('placeholder.alerte_raspuns_reclamatii'),
            inputValue: (this.client.alerts) ? this.client.alerts.alerte_raspuns_reclamatii : null
          },
          {
            inputName: 'mesaje_generale',
            labelName: this.$t('placeholder.mesaje_generale'),
            inputValue: (this.client.alerts) ? this.client.alerts.mesaje_generale : null
          },
          {
            inputName: 'mesaje_marketing',
            labelName: this.$t('placeholder.mesaje_marketing'),
            inputValue: (this.client.alerts) ? this.client.alerts.mesaje_marketing : null
          }
        ]
      }
    }
  }
}
</script>
